import React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

export default function GradientBackground({
  isVisible = true,
  darkMode = false,
}) {
  const theme = useTheme();

  if (!isVisible) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        pointerEvents: "none",
        overflow: "hidden",
        "@keyframes waveMove": {
          "0%": {
            transform: "translateX(-100%)",
          },
          "100%": {
            transform: "translateX(100%)",
          },
        },
      }}
    >
      {/* Single Curvy Wave */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "200%",
          height: "100%",
          background: `radial-gradient(ellipse 800px 200px at 50% 50%, ${
            darkMode
              ? `${theme.palette.secondary.main}55`
              : `${theme.palette.secondary.main}80`
          }, transparent 50%)`,
          clipPath:
            "polygon(0% 85%, 15% 88%, 30% 85%, 45% 82%, 60% 85%, 75% 88%, 90% 85%, 100% 88%, 100% 100%, 0% 100%)",
          animation: "waveMove 15s ease-in-out infinite",
          opacity: 1,
        }}
      />

      {/* Second overlapping wave for depth */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "200%",
          height: "100%",
          background: `radial-gradient(ellipse 600px 150px at 50% 60%, ${
            darkMode
              ? `${theme.palette.secondary.main}40`
              : `${theme.palette.secondary.main}65`
          }, transparent 50%)`,
          clipPath:
            "polygon(0% 90%, 20% 87%, 40% 90%, 60% 87%, 80% 90%, 100% 87%, 100% 100%, 0% 100%)",
          animation: "waveMove 20s ease-in-out infinite reverse",
          opacity: 0.9,
        }}
      />
    </Box>
  );
}
